<script lang="ts">
  import { getUser } from '$lib/auth.svelte';

  const user = $derived(getUser());
  const currentTier = $derived(user?.subscription_tier || 'free');

  const plans = [
    {
      name: 'Free',
      tier: 'free',
      price: '$0',
      period: 'forever',
      features: ['Join unlimited duels', 'Vote on tracks', 'Track your stats', 'Follow players', 'Basic achievements'],
    },
    {
      name: 'Pro',
      tier: 'pro',
      price: '$5',
      period: '/month',
      features: [
        'Everything in Free',
        'Create custom duels',
        'Priority track placement',
        'Advanced stats & insights',
        'Pro badge on profile',
        'Early access to features',
      ],
      highlight: true,
    },
  ];
</script>

<div>
  <h1>Plans</h1>
  <div class="plans-grid">
    {#each plans as plan}
      <div
        class="plan-card"
        class:plan-card--highlight={plan.highlight}
        class:plan-card--current={currentTier === plan.tier}
      >
        {#if currentTier === plan.tier}
          <span class="plan-badge">Current Plan</span>
        {/if}
        <h2 class="plan-name">{plan.name}</h2>
        <div class="plan-price">
          <span class="price-value">{plan.price}</span>
          <span class="price-period">{plan.period}</span>
        </div>
        <ul class="plan-features">
          {#each plan.features as feature}
            <li>{feature}</li>
          {/each}
        </ul>
        {#if currentTier === plan.tier}
          <button class="btn btn-outline full-width" disabled>Current</button>
        {:else if plan.tier === 'pro'}
          <button class="btn btn-primary full-width">Upgrade to Pro</button>
        {:else}
          <button class="btn btn-outline full-width" disabled>Free</button>
        {/if}
      </div>
    {/each}
  </div>
</div>

<style>
  h1 {
    margin-bottom: 1.5rem;
  }
  .plans-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 1.5rem;
  }
  .plan-card {
    position: relative;
    padding: 2rem 1.5rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .plan-card--highlight {
    border-color: var(--cyan);
  }
  .plan-card--current {
    border-color: var(--purple);
  }
  .plan-badge {
    position: absolute;
    top: -0.625rem;
    left: 50%;
    transform: translateX(-50%);
    background: var(--purple);
    color: #fff;
    font-size: 0.625rem;
    font-weight: 700;
    text-transform: uppercase;
    padding: 0.25rem 0.625rem;
    border-radius: 4px;
    white-space: nowrap;
  }
  .plan-name {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0 0 0.75rem;
    -webkit-text-fill-color: var(--text);
    background: none;
    background-clip: unset;
    -webkit-background-clip: unset;
  }
  .plan-price {
    margin-bottom: 1.25rem;
  }
  .price-value {
    font-size: 2rem;
    font-weight: 700;
    color: var(--cyan);
  }
  .price-period {
    font-size: 0.875rem;
    color: var(--text-muted);
  }
  .plan-features {
    list-style: none;
    padding: 0;
    margin: 0 0 1.5rem;
    width: 100%;
    text-align: left;
    font-size: 0.875rem;
  }
  .plan-features li {
    padding: 0.375rem 0;
    border-bottom: 1px solid rgba(42, 42, 42, 0.5);
    color: var(--text-secondary);
  }
  .plan-features li::before {
    content: '✓ ';
    color: var(--cyan);
    font-weight: 600;
  }
  .full-width {
    width: 100%;
  }
</style>
